import 'flexboxgrid';
import './index.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App/App';
import { store, history } from './App/store';
import { Provider } from 'react-redux';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
  <Provider store={store}>
    <App history={history} />
  </Provider>
  , document.getElementById('root')
);

if (module.hot && process.env.NODE_ENV !== 'production') {
  module.hot.accept();
}

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js